import { Button } from '@cibli/shared';
import { Monitor } from 'lucide-react';
import { useState } from 'react';

import { MediaDevicesDialog } from './MediaDevicesDialog';

export function MediaDevices() {
  const [showMediaDevices, setShowMediaDevices] = useState(false);

  return (
    <>
      <div className="">
        <Button variant="outline" onClick={() => setShowMediaDevices(true)} className="w-full">
          <Monitor className="w-4 h-4 mr-2" />
          Périphériques média
        </Button>
      </div>

      {showMediaDevices && <MediaDevicesDialog open onOpenChange={setShowMediaDevices} />}
    </>
  );
}
